export default "__VITE_ASSET__1229f76f__"